import { render } from "./intros.vue?vue&type=template&id=8a9f6e18&lang=pug"
import script from "./intros.vue?vue&type=script&lang=js"
export * from "./intros.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__